import Color from 'color'
import { colorService } from '../common/color.service'

class LineColorService {
  setChartColors (series, colorCache, nextColorIndex) {
    // Grab the colors that are already set
    const usedColors = []
    series.forEach(({ color }) => {
      if (color) {
        usedColors.push(color)
      }
    })

    // Set colors for any series that are not already set
    series.forEach((s) => {
      if (!s.color) {
        const { color, nextIndex } = colorService.pickNextBestColor({
          usedColors,
          cachedColor: colorCache[s.id],
          nextIndex: nextColorIndex
        })
        s.color = color
        usedColors.push(color)
        colorCache[s.id] = color
        nextColorIndex = nextIndex
      }

      const bandCount = s.bands?.length
      const bandColors = this.getBandColors(s.color, bandCount)
      s.bands?.forEach((band, i) => {
        band.color = bandColors[i]
      })
    })

    return {
      series,
      colorCache,
      nextColorIndex,
      colors: series.map((s) => s.color)
    }
  }

  /**
   * Get a list of band colors ranging from light to dark within an acceptable range
   */
  getBandColors (lineColor, count = 0) {
    const bandColors = []
    if (count === 0) {
      return bandColors
    }
    const lightest = 0.8
    const darkest = 0.5

    // if more than one band, divide up the acceptable range into even chunks
    const increment = (count > 1) ? (lightest - darkest) / (count - 1) : 0
    let next = lightest
    for (let i = 0; i < count; i++) {
      bandColors.push(Color(lineColor).fade(next))
      next -= increment
    }
    return bandColors
  }
}

export const lineColorService = new LineColorService()
